var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"up"},[_vm._t("up")],2),_c('div',{staticClass:"center"},[_vm._t("center")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }